module.exports = __webpack_public_path__ + "media/application/images/2018/icon-top-brand-99e65d28ca37f68ad86548d1d574a7ce.svg";